import { Box, Typography } from "@mui/material";
import FitnessAssessmentCard from "./FitnessAssessmentCard";
import { FitnessProfileAlgorithm, WahooWorkoutTypeFamily } from "@WahooFitness/cloud-client-types";
import { useMemo } from "react";
import getEstimateText from "./getEstimateText";

function EstimateDrawer({
  algorithmId,
  fitnessProfileType = WahooWorkoutTypeFamily.Cycling,
}: {
  algorithmId?: FitnessProfileAlgorithm;
  fitnessProfileType?: WahooWorkoutTypeFamily;
}) {
  const isRunning = fitnessProfileType === WahooWorkoutTypeFamily.Running;

  const text = useMemo(() => getEstimateText({ algorithmId, isRunning }), [algorithmId, isRunning]);

  return (
    <Box display="flex" flexDirection="column" alignItems="center" p={2} pb={4} gap={3}>
      <Typography variant="prose-base">{text}</Typography>
      {!isRunning && algorithmId !== FitnessProfileAlgorithm.Custom && <FitnessAssessmentCard />}
    </Box>
  );
}

export default EstimateDrawer;
